/** Frases dos componentes partilhados (na língua da interface). */
import { catalog } from '@nolens/i18n';
import type { AnnotationColor } from '@nolens/domain';

export const uiText = catalog(
  {
    close: 'Close',
    loading: 'Loading…',
    loadError: "Couldn't load this page",
    loadErrorHint: 'Check your connection and try again.',
    retry: 'Try again',
    reference: (id: string) => `Reference: ${id}`,
    appsUsed: 'Apps used',
    // Editor de imagem
    editImage: 'Edit image',
    tool: 'Tool',
    color: 'Color',
    toolBox: 'Highlight',
    toolArrow: 'Arrow',
    toolBlur: 'Blur',
    toolCrop: 'Crop',
    toolPoint: 'Click point',
    hintBox: 'Drag over the image to highlight an area.',
    hintArrow: 'Drag from the start to the end of the arrow.',
    hintBlur: 'Drag over what you want to hide. The blur stays in the image.',
    hintCrop: 'Drag over the image to choose the part to show.',
    hintPoint: 'Click where the click marker should appear.',
    undo: 'Undo',
    clearAll: 'Clear all',
    noCrop: 'No crop',
    noMarker: 'No marker',
    cancel: 'Cancel',
    save: 'Save',
    stepScreenshot: 'Step screenshot',
    colorName: (c: AnnotationColor) =>
      ({ red: 'Red', orange: 'Orange', blue: 'Blue', green: 'Green' })[c],
    // Execução automática
    onRun: 'When running',
    suggested: ' (suggested)',
    value: 'Value',
    noValue: 'No value (the person types)',
    askAtStart: 'Ask at the start',
    fixedText: 'Fixed text',
    relativeDate: 'Relative date',
    question: 'Question',
    questionPlaceholder: 'Question (e.g. Store code)',
    textToType: 'Text to type',
    date: 'Date',
    dateFormat: 'Date format',
    setValueFirst: 'Set the value to type first.',
    forcedSensitive: 'Sensitive field: the person always fills it in.',
    forcedNoTarget: 'No recorded element: the person does this step.',
    forcedNoOption: 'No recorded option: the person chooses.',
    defaultText: 'text',
  },
  {
    'pt-PT': {
      close: 'Fechar',
      loading: 'A carregar…',
      loadError: 'Não foi possível carregar esta página',
      loadErrorHint: 'Verifique a ligação e tente novamente.',
      retry: 'Tentar novamente',
      reference: (id) => `Referência: ${id}`,
      appsUsed: 'Aplicações usadas',
      editImage: 'Editar imagem',
      tool: 'Ferramenta',
      color: 'Cor',
      toolBox: 'Destacar',
      toolArrow: 'Seta',
      toolBlur: 'Desfocar',
      toolCrop: 'Recortar',
      toolPoint: 'Ponto do clique',
      hintBox: 'Arraste sobre a imagem para destacar uma zona.',
      hintArrow: 'Arraste do início para o fim da seta.',
      hintBlur: 'Arraste sobre o que quer esconder. O desfoque fica na imagem.',
      hintCrop: 'Arraste sobre a imagem para escolher a parte a mostrar.',
      hintPoint: 'Clique onde deve aparecer o marcador do clique.',
      undo: 'Desfazer',
      clearAll: 'Apagar tudo',
      noCrop: 'Sem recorte',
      noMarker: 'Sem marcador',
      cancel: 'Cancelar',
      save: 'Guardar',
      stepScreenshot: 'Captura do passo',
      colorName: (c) => ({ red: 'Vermelho', orange: 'Laranja', blue: 'Azul', green: 'Verde' })[c],
      onRun: 'Ao executar',
      suggested: ' (sugestão)',
      value: 'Valor',
      noValue: 'Sem valor (a pessoa escreve)',
      askAtStart: 'Perguntar no início',
      fixedText: 'Texto fixo',
      relativeDate: 'Data relativa',
      question: 'Pergunta',
      questionPlaceholder: 'Pergunta (ex.: Código da loja)',
      textToType: 'Texto a escrever',
      date: 'Data',
      dateFormat: 'Formato da data',
      setValueFirst: 'Defina primeiro o valor a escrever.',
      forcedSensitive: 'Campo sensível: é sempre a pessoa que o preenche.',
      forcedNoTarget: 'Sem o elemento gravado: é a pessoa que faz este passo.',
      forcedNoOption: 'Sem a opção gravada: é a pessoa que escolhe.',
      defaultText: 'texto',
    },
  },
);
